import { useDispatch } from 'react-redux';

import { ClickToCallAgentOpenInputDto, ClickToCallAgentOpenOutputDto } from '@api/ecommerce-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchClickToCallAgentOpen = (): UseFetchHookOutput<
	Omit<ClickToCallAgentOpenInputDto, 'metadata'>,
	ClickToCallAgentOpenOutputDto
> => {
	const dispatch = useDispatch();
	return useFetch<ClickToCallAgentOpenInputDto, ClickToCallAgentOpenOutputDto>({
		operationKey: 'clickToCallAgentOpen',
		withLoading: false,
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ clickToCallAgentOpen: res.data }));
			}
		},
	});
};
